import { Box, Heading, Text } from '@wix/design-system';
import classNames from 'classnames';
import React from 'react';
import s from '../MobileProductCard.scss';
export const MobileProductCardTitle = ({ className, dataHook, title, description, }) => {
    return (React.createElement(Box, { direction: "vertical" },
        React.createElement(Heading, { className: classNames(className, s.title), dataHook: dataHook, appearance: "H3" }, title),
        React.createElement(Text, { size: "small" }, description)));
};
//# sourceMappingURL=MobileProductCardTitle.js.map